import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getUserProfileService, updateProfileService } from "../../../services/userServices";

import { Profile, UserProfile } from "MyAccountPlus-UIComponents";

const initialState: UserProfile = {
    loading: false,
    error: "",
    user: {
        account_ids: [],
        alerts: [],
        autopayments: [],
        billing_address: {
            street1: '',
            street2: '',
            city: '',
            state: '',
            zipcode: ''
        },
        cell_phone: '',
        contact_type_id: undefined,
        display_name: '',
        email: '',
        first_name: '',
        home_phone: '',
        last_manually_updated: 0,
        last_name: '',
        notify_options: [],
        paperless_delivery: false,
        payment_sources: [],
        user_id: '',
        name: '',
        locale: '',
        notifications_wanted: [],
        role: '',
        town_notifications: [],
        winter_address: {
            street1: "",
            city: "",
            state: "",
            zipcode: ""
        },
        terms_of_use_acknowledged: false
    }
}

export const getUserProfileThunk = createAsyncThunk("profileSlice/getUserProfileThunk", async (args: { email?: string } | undefined, thunkAPI) => {
    try {
        const { data } = await getUserProfileService(args?.email);
        return { data };
    } catch (error: any) {
        console.log("error--", error.response.data);
        if (!error.response) {
            throw error;
        }
        return thunkAPI.rejectWithValue('(' + error.response.data.status + ') ' + error.response.data.detail);
    }
});

export const updateProfileThunk = createAsyncThunk("profileSlice/updateProfileThunk", async (args: Profile, thunkAPI) => {
    try {
        const { data } = await updateProfileService(args);
        return { data }
    } catch (error: any) {
        console.log("error--", error.response.data);
        if (!error.response) {
            throw error
        }
        return thunkAPI.rejectWithValue('(' + error.response.data.status + ') ' + error.response.data.detail);
    }
})

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        errorReducer: (state) => {
            state.error = ""
        },
        successReducer: (state) => {
            state.success = ""
        },
        clearState: (state) => {
            return initialState;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getUserProfileThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getUserProfileThunk.fulfilled, (state, action) => {
                state.user = action.payload.data.profile
                state.loading = false
                state.error = ""
            })
            .addCase(getUserProfileThunk.rejected, (state, action) => {
                state.error = action.payload as string || action.error.message!
                state.loading = false
            })
            .addCase(updateProfileThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(updateProfileThunk.fulfilled, (state, action) => {
                state.success = "Profile updated successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(updateProfileThunk.rejected, (state, action) => {
                state.error = action.payload as string || action.error.message || "";
                state.loading = false
            })
    },
})

export const profileActions = profileSlice.actions
export default profileSlice.reducer;